import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import { Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

// Search table wrapper start

const SearchTable = ({ title, searchTerm, searchedDataOfContact, gotData, tableHeadings, children }) => {

    let newTitle = "";

    if(title=="My Profile") {
        newTitle = "Contacts";
    } else if(title=="My Account") {
        newTitle = "Accounts";
    } else {
        newTitle = title;
    }

    const totalSize = searchedDataOfContact?.data?.[newTitle]?.totalSize || '0';

  return (
    <>
    <Grid item xs={12} style={{ margin: "10px 5px" }}>

<Grid container alignItems="center" justifyContent="space-between" style={{ marginTop: "10px" }}>
<Typography
    component="h1"
    variant="h6"
    color="inherit"
    noWrap
    sx={{ flexGrow: 1, textAlign: 'left', marginLeft: 2, fontWeight: 'bold' }}
>
    {title}
</Typography>
<Link to={`/${newTitle}/${searchTerm}`} style={{ textDecoration: 'none', color: '#1976D2', fontSize: "14px" }}>
    View More
</Link>
</Grid>
<Typography component="p" style={{ fontSize: "12px", lineHeight: "0px", margin: "5px 0px 5px 18px", textAlign: "left" }}>
{totalSize <= 5 ? totalSize + ' Results' : '5+ Results'}
</Typography>
<Divider style={{ fontWeight: "bold", margin: "15px 0px 0px 0px", backgroundColor: "black" }} />
<Divider style={{ fontWeight: "bold", margin: "2px 0px 5px 0px", backgroundColor: "black" }} />

{ (gotData == false && searchedDataOfContact.success == false) ? <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'  }}>
<CircularProgress />
</Box> : ((totalSize) != 0 ? <Table size="small">
<TableHead>
<TableRow>
    { tableHeadings.map((tableHead) => {
        return <TableCell sx={{ fontWeight: 'bold' }}>{tableHead}</TableCell>
    }) }
</TableRow>
</TableHead>
<TableBody>
{children}
</TableBody>
</Table> : <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'}}><p>No Records Found!</p></div>)  }

</Grid>
    </>
  );
};

// Search table wrapper end

export default SearchTable;
